<template>
    <div class="ai-draft-modal-backdrop" @click.self="$emit('cancel')">
        <div class="ai-draft-modal">
            <div class="ai-draft-modal-header">
                <h3>
                    <i class="fa fa-envelope-open"></i>
                    Paste an enquiry
                </h3>
                <button type="button" class="ai-draft-modal-close" @click="$emit('cancel')" aria-label="Close">
                    &times;
                </button>
            </div>

            <div class="ai-draft-modal-body">
                <p class="ai-draft-muted" style="margin-top:0">
                    Paste the full email — name, contact details, what they want, sizes,
                    deadlines. I'll extract what I need and ask if anything's missing.
                </p>
                <textarea
                    ref="textarea"
                    v-model="text"
                    class="ai-draft-textarea"
                    rows="12"
                    placeholder="From: Sarah Patel <sarah@tate.org.uk>&#10;&#10;Hi,&#10;Could you quote framing for an A2 limited-edition print..."
                ></textarea>
            </div>

            <div class="ai-draft-modal-footer">
                <button
                    type="button"
                    class="ai-draft-btn ai-draft-btn-ghost"
                    @click="$emit('cancel')"
                >
                    Cancel
                </button>
                <button
                    type="button"
                    class="ai-draft-btn ai-draft-btn-primary"
                    :disabled="!text.trim()"
                    @click="submit"
                >
                    Draft from this enquiry <i class="fa fa-arrow-right"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({ text: '' }),

    mounted() {
        this.$nextTick(() => this.$refs.textarea.focus());
        document.addEventListener('keydown', this.onKey);
    },

    beforeDestroy() {
        document.removeEventListener('keydown', this.onKey);
    },

    methods: {
        onKey(e) {
            if (e.key === 'Escape') this.$emit('cancel');
        },
        submit() {
            const t = this.text.trim();
            if (!t) return;
            this.$emit('submit', t);
        },
    },
};
</script>

<style>
.ai-draft-modal-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, .5);
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.ai-draft-modal {
    background: var(--ai-card);
    border-radius: var(--ai-radius);
    width: 100%;
    max-width: 640px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 20px 50px rgba(15, 23, 42, .25);
    overflow: hidden;
}

.ai-draft-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid var(--ai-border);
}

.ai-draft-modal-header h3 {
    font-size: 16px;
    font-weight: 600;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
}

.ai-draft-modal-header h3 .fa {
    color: var(--ai-primary);
}

.ai-draft-modal-close {
    background: none;
    border: none;
    font-size: 24px;
    line-height: 1;
    color: var(--ai-muted);
    cursor: pointer;
    padding: 0 4px;
}

.ai-draft-modal-close:hover {
    color: var(--ai-text);
}

.ai-draft-modal-body {
    padding: 20px;
    overflow-y: auto;
    flex: 1;
}

.ai-draft-modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 12px 20px;
    border-top: 1px solid var(--ai-border);
    background: #fafbfc;
}
</style>
